import { Plugins } from "@capacitor/core";
const { LocalNotifications } = Plugins;
import { FCM } from "@capacitor-community/fcm";
import { PushNotifications } from "@capacitor/push-notifications";
import router from "@/router/index";

async function fcmSetting() {
  console.log("FcmSetting");
  await PushNotifications.requestPermissions()
    .then((value) => {
      console.log("request permision then", value);
      PushNotifications.register();
      if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        FCM.getToken()
          .then((r) => {
            console.log("ios fcm token get", r);
            localStorage.setItem("fcmtoken", r.token);
          })
          .catch((err) => {
            console.log("ios fcm token get err", err);
          });
      }
    })
    .catch((reason) => {
      console.log("request permision catch", reason);
    });

  if (/Android/i.test(navigator.userAgent)) {
    // 안드로이드
    PushNotifications.addListener("registration", (token) => {
      console.log("android fcm token", token.value);
      localStorage.setItem("fcmtoken", token.value);
    });

    PushNotifications.addListener("registrationError", (error) => {
      alert("Error on registration: " + JSON.stringify(error));
    });
  }

  PushNotifications.addListener("pushNotificationReceived", async (notification) => {
    console.log("received");
    sendNotification(notification);
  });
}

async function receivedNotifcation() {
  PushNotifications.addListener("pushNotificationActionPerformed", () => {
    router.push({ path: "/coaching_message" }).catch(() => {});
  });
}

async function sendNotification(data) {
  console.log("sendNotification", data);
  let bodyText = data.body.replace(/(<([^>]+)>)/gi, "");
  const notifs = await LocalNotifications.schedule({
    notifications: [
      {
        title: data.title,
        body: bodyText,
        id: 1,
        schedule: { at: new Date(Date.now() + 100) },
        sound: null,
        attachments: null,
        actionTypeId: "",
        extra: null,
        foreground: false,
      },
    ],
  });

  await LocalNotifications.addListener("localNotificationActionPerformed", async (notification) => {
    const data = notification.notification.data;
    console.log("localNotificationActionPerformed: " + JSON.stringify(notification.notification));
    console.log(data);
    router.push({ path: "/coaching_message" }).catch(() => {});
  });
}

export { fcmSetting, sendNotification, receivedNotifcation };
